module.exports = __webpack_public_path__ + "static/2017-aeta-outreach2-f1d6d7f56ce322d3a1ce58be8d10ac2a.jpg";